import React, { useContext, useState } from "react";
import { LoggedInInfo } from "../types";

interface IAppContextProps {
  loggedInInfo: LoggedInInfo;
  setLoggedInInfo: (info: LoggedInInfo) => void;
  clearLoggedInInfo: () => void;
}

const Context = React.createContext({} as IAppContextProps);

const AppContext: React.FunctionComponent<{
  children: React.ReactNode;
}> = (props) => {
  const [loggedInInfo, setLoggedInInfo] = useState({
    isLoggedIn: false,
  });

  const clearLoggedInInfo = () => {
    setLoggedInInfo({
      isLoggedIn: false,
    });
  };

  return (
    <Context.Provider
      value={{
        loggedInInfo,
        setLoggedInInfo,
        clearLoggedInInfo,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const useAppContext = () => {
  return useContext(Context);
};

export default AppContext;
